export const OptionView = (props: {
	id: string
	title: string
	selected: boolean
	handleSelect: (id: string, target: EventTarget) => void
	description?: string
	disabled?: boolean
	className?: string
}) => {
	return (
		<label
			data-test-id={props.id}
			aria-label={props.title}
			className={`flex w-full shrink-0 cursor-pointer flex-row items-start space-x-2 rounded-md bg-base-700 aria-disabled:pointer-events-none aria-disabled:opacity-50 ${props.className}`}
			onClick={(e) => props.handleSelect(props.id, e.target)}
			aria-disabled={props.disabled}
		>
			<input
				className="my-[3px]"
				type="radio"
				checked={props.selected}
				onChange={(e) => props.handleSelect(props.id, e.target)}
			/>
			<div className="flex flex-col space-y-2">
				<div className="text-sm">{props.title}</div>
				{props.description && (
					<div className="text-xs text-base-400">{props.description}</div>
				)}
			</div>
		</label>
	)
}
